import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SOL}${process.env.VUE_APP_API_PATH}/sol`;

const urlBase = `${api}/chamados`;

export default {
    obterTodos(status) {
        let params = '';
        status.forEach((st) => {
            params += `status=${st}&`;
        });

        return axiosJwt.get(`${urlBase}?${params}`);
    },
    obterOrigemPorChamado(chamado) {
        return axiosJwt.post(`${urlBase}/origem`, chamado);
    },
    atenderChamado(id) {
        return axiosJwt.put(`${urlBase}/atender/${id}`);
    },
    responderChamado(id, resposta) {
        return axiosJwt.post(`${urlBase}/${id}/resposta`, resposta);
    },
    atribuirNovoResponsavelChamado(chamado) {
        return axiosJwt.post(`${urlBase}/atribuirNovoResponsavel`, chamado);
    },
    gerarRelatorioProdutoReal(inicio, fim) {
        return axiosJwt.get(`${urlBase}/relatorio/produtoReal?inicio=${inicio}&fim=${fim}`, { responseType: 'blob' });
    },
    gerarRelatorioCuradoria(inicio, fim) {
        return axiosJwt.get(`${urlBase}/relatorio/curadoria?inicio=${inicio}&fim=${fim}`, { responseType: 'blob' });
    },
};
